import type { TranslationDict } from '../en';

const fa: TranslationDict = {
  // ─── Header ───
  'header.buy': 'خرید',
  'header.sell': 'فروش',

  // ─── SpendCard ───
  'spend.label': 'پرداخت می‌کنید',
  'spend.placeholderFiat': '250',
  'spend.placeholderCrypto': '0.01',

  // ─── ReceiveCard ───
  'receive.label': 'دریافت می‌کنید',

  // ─── PaymentCard ───
  'payment.label': 'روش پرداخت',
  'payment.select': 'انتخاب',
  'provider.label': 'By',
  'provider.select': 'Select',
  'provider.unavailable': 'Unavailable',
  'provider.unavailablePayment': 'Payment method not supported',
  'provider.unavailableCountry': 'Region not supported',
  'provider.unavailableCurrency': 'Currency not supported',
  'provider.unavailableNetwork': 'Network not supported',
  'payment.noneAvailable': 'هیچ روش پرداختی برای این جفت وجود ندارد',

  // ─── WalletCard ───
  'wallet.label': 'آدرس کیف پول دریافت',
  'wallet.placeholderBuy': 'آدرس دریافت خود را وارد کنید',
  'wallet.placeholderSell': 'آدرس ارسال خود را وارد کنید',
  'wallet.validating': 'در حال تأیید آدرس...',
  'wallet.invalid': 'یک آدرس کیف پول معتبر وارد کنید',
  'wallet.invalidServer': 'آدرس کیف پول نامعتبر است',

  // ─── CtaButton ───
  'cta.buy': 'خرید {crypto}',
  'cta.sell': 'فروش {crypto}',
  'cta.gettingPrice': 'در حال دریافت بهترین قیمت...',
  'cta.processing': 'در حال پردازش...',

  // ─── Footer ───
  'footer.poweredBy': 'ارائه شده توسط ',
  'footer.brand': 'NowRamp',

  // ─── Rate Breakdown ───
  'rate.title': 'جزئیات نرخ',
  'rate.close': 'بستن',
  'rate.updatesIn': 'نرخ در 00:{seconds} به‌روز می‌شود',
  'rate.noQuote': 'قیمتی در دسترس نیست',
  'rate.exchangeRate': 'نرخ تبادل',
  'rate.processingFee': 'کارمزد پردازش',
  'rate.networkFee': 'کارمزد شبکه',
  'rate.provider': 'ارائه‌دهنده',

  // ─── Toast ───
  'toast.orderCreated': 'سفارش ایجاد شد',
  'toast.redirecting': 'در حال هدایت به صفحه پرداخت...',
  'toast.orderFailed': 'سفارش ناموفق بود',
  'toast.couldNotCreate': 'ایجاد سفارش ممکن نشد',
  'toast.quoteError': 'خطا در دریافت قیمت',
  'toast.noProviders': 'هیچ ارائه‌دهنده‌ای یافت نشد',
  'toast.somethingWrong': 'مشکلی پیش آمد',

  // ─── Form errors ───
  'error.amountZero': 'مبلغ باید بیشتر از ۰ باشد',
  'error.minAmountFiat': 'حداقل مبلغ {min} {currency} است',
  'error.minAmountCrypto': 'حداقل مبلغ {min} {currency} است',
  'error.noProviders': 'هیچ ارائه‌دهنده‌ای برای این ترکیب موجود نیست',
  'error.currencyUnavailableBuy': 'این ارز برای سفارش خرید در دسترس نیست',
  'error.currencyUnavailableSell': 'این ارز برای سفارش فروش در دسترس نیست',

  // ─── Parity banner ───
  'parity.info': 'مبلغ {receiveAmount} {crypto} از شما دریافت می‌شود و مابقی تا {spendAmount} {fiat} به حساب {partner} شما واریز خواهد شد',

  // ─── Redirect Screen ───
  'redirect.secureBadge': 'پرداخت امن',
  'redirect.title': 'ادامه پرداخت',
  'redirect.description': 'برای تکمیل پرداخت به {gateway} هدایت می‌شوید.',
  'redirect.countdown': 'هدایت در {seconds} ثانیه...',
  'redirect.openTab': 'باز کردن ACH در تب جدید',
  'redirect.cancel': 'انصراف',

  // ─── Checkout Step ───
  'checkout.noOrder': 'سفارشی یافت نشد',
  'checkout.goBack': 'بازگشت',
  'checkout.expired': 'پرداخت منقضی شده است',
  'checkout.expiredDesc': 'نشست منقضی شده است. لطفاً دوباره تلاش کنید.',
  'checkout.startOver': 'شروع مجدد',
  'checkout.cancel': 'انصراف',
  'checkout.loading': 'در حال بارگذاری صفحه پرداخت...',
  'checkout.iframeTitle': 'پرداخت ارائه‌دهنده',
  'checkout.widgetTitle': 'صفحه پرداخت',
  'checkout.unknownMethod': 'روش پرداخت ناشناخته',

  // ─── Processing Step ───
  'processing.default': 'در حال پردازش سفارش...',
  'processing.pending': 'در انتظار تأیید پرداخت...',
  'processing.active': 'در حال پردازش تراکنش...',
  'processing.generic': 'در حال پردازش...',
  'processing.checkingStatus': 'در حال بررسی وضعیت...',
  'processing.orderId': 'شناسه سفارش',
  'processing.provider': 'ارائه‌دهنده',
  'processing.amount': 'مبلغ',
  'processing.receiving': 'دریافت',
  'processing.network': 'شبکه',
  'processing.toAddress': 'آدرس مقصد',
  'processing.usuallyMinutes': 'این فرایند معمولاً چند دقیقه طول می‌کشد.',
  'processing.safeToClose': 'می‌توانید این صفحه را ببندید — پس از اتمام، یک ایمیل برای شما ارسال می‌کنیم.',

  // ─── Complete Step ───
  'complete.buyTitle': 'خرید با موفقیت انجام شد!',
  'complete.sellTitle': 'فروش با موفقیت انجام شد!',
  'complete.buyDesc': '{crypto} شما به کیف پولتان ارسال شد.',
  'complete.sellDesc': 'پرداخت {fiat} شما در حال پردازش است.',
  'complete.amountBuy': 'مبلغ دریافتی',
  'complete.amountSell': 'مبلغ فروخته شده',
  'complete.paidBuy': 'مبلغ پرداخت شده',
  'complete.paidSell': 'مبلغ پرداختی',
  'complete.network': 'شبکه',
  'complete.wallet': 'کیف پول',
  'complete.transaction': 'تراکنش',
  'complete.provider': 'ارائه‌دهنده',
  'complete.orderId': 'شناسه سفارش',
  'complete.completed': 'تکمیل شد',
  'complete.viewExplorer': 'مشاهده در اکسپلورر',
  'complete.done': 'پایان',

  // ─── Error Step ───
  'errorStep.failed': 'پرداخت ناموفق',
  'errorStep.cancelled': 'سفارش لغو شد',
  'errorStep.expired': 'سفارش منقضی شد',
  'errorStep.refunded': 'سفارش بازگشت داده شد',
  'errorStep.unknown': 'مشکلی پیش آمد',
  'errorStep.failedBuy': 'پرداخت شما قابل پردازش نبود. لطفاً دوباره تلاش کنید یا از روش پرداخت دیگری استفاده کنید.',
  'errorStep.failedSell': 'فروش شما قابل پردازش نبود. لطفاً دوباره تلاش کنید.',
  'errorStep.cancelledBuy': 'سفارش شما لغو شد. هیچ پرداختی انجام نشده است.',
  'errorStep.cancelledSell': 'فروش شما لغو شد. هیچ ارز دیجیتالی منتقل نشده است.',
  'errorStep.expiredBuy': 'سفارش شما منقضی شده است. لطفاً خرید جدیدی آغاز کنید.',
  'errorStep.expiredSell': 'سفارش شما منقضی شده است. لطفاً فروش جدیدی آغاز کنید.',
  'errorStep.refundedBuy': 'مبلغ پرداختی شما بازگشت داده شده است. وجه ظرف ۵ تا ۱۰ روز کاری در حسابتان ظاهر می‌شود.',
  'errorStep.refundedSell': 'ارز دیجیتال شما برگشت داده شده است. وجه به زودی در کیف پولتان ظاهر می‌شود.',
  'errorStep.genericDesc': 'یک خطای غیرمنتظره رخ داد. لطفاً دوباره تلاش کنید.',
  'errorStep.orderId': 'شناسه سفارش',
  'errorStep.tryAgain': 'تلاش مجدد',
  'errorStep.startOver': 'شروع مجدد',
  'errorStep.return': 'بازگشت',
  'errorStep.needHelp': 'نیاز به کمک دارید؟ تماس بگیرید با ',
  'errorStep.reference': 'مرجع: {orderId}',

  // ─── Confirm Step ───
  'confirm.buyTitle': 'تأیید خرید',
  'confirm.sellTitle': 'تأیید فروش',
  'confirm.loading': 'در حال بارگذاری...',
  'confirm.provider': 'ارائه‌دهنده',
  'confirm.youPay': 'شما پرداخت می‌کنید',
  'confirm.youSell': 'شما می‌فروشید',
  'confirm.youReceive': 'شما دریافت می‌کنید',
  'confirm.wallet': 'کیف پول',
  'confirm.network': 'شبکه',
  'confirm.refundAddress': 'آدرس بازگشت وجه',
  'confirm.parityNote': 'مبلغ دریافتی از ارائه‌دهنده ممکن است متفاوت باشد. مابقی تا {amount} {crypto} به حساب {partner} شما واریز می‌شود.',
  'confirm.processing': 'در حال پردازش...',
  'confirm.confirmPay': 'تأیید و پرداخت',
  'confirm.confirmSell': 'تأیید و فروش',
  'confirm.payout': 'پرداخت {currency}',

  // ─── Modals ───
  'modal.selectFiat': 'انتخاب ارز فیات',
  'modal.selectCrypto': 'انتخاب ارز دیجیتال',
  'modal.choosePayment': 'انتخاب روش پرداخت',
  'modal.selectCountry': 'انتخاب کشور',
  'modal.selectLanguage': 'Select language',
  'modal.popular': 'محبوب',
  'modal.recommended': 'پیشنهادی',
  'modal.noCurrencies': 'ارزی یافت نشد',
  'modal.noPaymentMethods': 'روش پرداختی یافت نشد',
  'modal.noCountries': 'کشوری یافت نشد',
  'modal.noLanguages': 'No languages found',

  // ─── Settings ───
  'settings.location': 'موقعیت مکانی',
  'settings.darkMode': 'حالت تاریک',
  'settings.privacy': 'سیاست حریم خصوصی',
  'settings.terms': 'شرایط استفاده',
  'settings.language': 'زبان',

  // ─── Additional ───
  'modal.chooseRamp': 'انتخاب Ramp',
  'modal.bestPrice': 'بهترین قیمت',
  'modal.noQuotes': 'هیچ قیمتی برای این درخواست در دسترس نیست',
  'modal.noProvidersFound': 'هیچ ارائه‌دهنده‌ای یافت نشد',
  'payment.unavailableFor': 'هیچ روش پرداختی برای {currency} در دسترس نیست',
  'skeleton.poweredBy': 'Powered by NowRamp',
  'error.createOrderFailed': 'ایجاد سفارش ناموفق بود',
  'errorStep.returnToMerchant': 'بازگشت به فروشنده',
  'confirm.cryptoOnNetwork': '{crypto} بر روی {network}',
  'payment.name.card': 'کارت',
  'payment.name.bankTransfer': 'انتقال بانکی',
  'payment.name.ach': 'ACH',
  'rate.updatesInLabel': 'Rate updates in',
  'rate.networkFeeIncl': 'Network fee incl.',
  'rate.rateTooltip': 'As the market is highly volatile, we can fix the exchange rate for no longer than 30 seconds.',
  'rate.networkFeeTooltip': 'Includes a fee charged by blockchain to execute the transaction.',
  'rate.feeIncluded': '{percentage}% incl.',
  'receive.fetchingRate': 'Fetching best rate...',
  'redirect.tabHelper': 'If the new tab has not opened, click the button above.',
};

export default fa;
